var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuRadial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0485 41.6567V34.1799H41.7388V18.8701H34.2619V34.1799H18.9522V41.6567H34.2619V56.9665H41.7388V41.6567H57.0485ZM11.1193 11.2153C18.5961 3.73843 27.5565 0 38.0004 0C48.4442 0 57.3452 3.73843 64.7034 11.2153C72.1802 18.5735 75.9187 27.4745 75.9187 37.9183C75.9187 48.3622 72.1802 57.3225 64.7034 64.7994C57.3452 72.1576 48.4442 75.8366 38.0004 75.8366C27.5565 75.8366 18.5961 72.1576 11.1193 64.7994C3.76112 57.3225 0.0820312 48.3622 0.0820312 37.9183C0.0820312 27.4745 3.76112 18.5735 11.1193 11.2153Z",
    fill: "#009973"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuRadial);
export default __webpack_public_path__ + "static/media/menu_radial.f85a5e029c899c37695269f406e87f62.svg";
export { ForwardRef as ReactComponent };